
<template>
  <!-- 虚拟表计算 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="calculateMoney" v-if="ERP.isPermission(4007006001)">计算</el-button>
           <el-button @click="updateDate" v-if="ERP.isPermission(4007006002)">修改计费周期</el-button>
           <el-button @click="del" v-if="ERP.isPermission(4007006003)">删除</el-button>
           <el-button @click="del_list" v-if="ERP.isPermission(4007006004)">全部删除</el-button>
           <el-button @click="log" v-if="ERP.isPermission(4007006005)">查看日记</el-button>
           <el-button @click="closing" v-if="ERP.isPermission(4007006006)">审核</el-button>
           <el-button @click="back_closing" v-if="ERP.isPermission(4007006007)">反审核</el-button>
           <el-button @click="list_closing" v-if="ERP.isPermission(4007006008)">全部审核</el-button>
           <el-button @click="back_list_closing" v-if="ERP.isPermission(4007006009)">全部反审核</el-button>
         </div>

         <div style="margin-bottom: 10px;">
           <el-descriptions :column="2" border size="mini" :labelStyle="{width: '123px'}" :contentStyle="{width:'43%'}">
             <el-descriptions-item label="查询条件">
               {{house}}
             </el-descriptions-item>
             <el-descriptions-item label="虚拟表性质">
               <CheckboxGroup v-model="data.meter_kind">
                   <Checkbox label="计量表"></Checkbox>
                   <Checkbox label="分摊计费表"></Checkbox>
               </CheckboxGroup>
             </el-descriptions-item>
             <el-descriptions-item label="虚拟表名称">
               <el-input size="mini" placeholder="虚拟表名称" v-model="data.dummy_meter_name" clearable></el-input>
             </el-descriptions-item>
            <el-descriptions-item label="仪表类型">
               <CheckboxGroup v-model="data.meter_type_id">
                   <Checkbox v-for="it in meter_type_list" :label="it.id" :key="it.id">{{it.name}}</Checkbox>
               </CheckboxGroup>
            </el-descriptions-item>
            <el-descriptions-item label="户号">
                <el-input size="mini" placeholder="户号" v-model="data.house_number" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="上期抄表日期">
                <el-date-picker size="mini" v-model="data.calc_start_date" type="date" placeholder="上期抄表日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="审核标记">
                <CheckboxGroup v-model="data.is_closing">
                    <Checkbox label="未审核"></Checkbox>
                    <Checkbox label="已审核"></Checkbox>
                </CheckboxGroup>
            </el-descriptions-item>
            <el-descriptions-item label="本期抄表日期">
               <el-date-picker size="mini" v-model="data.calc_end_date" type="date" placeholder="本期抄表日期"></el-date-picker>
            </el-descriptions-item>
           </el-descriptions>
         </div>
        <div v-if="logs == 1">
          <div style="width: 100%;">
            <el-table ref="multipleTable" :data="tableData" height="50vh" border tooltip-effect="dark" style="position:relative;width: 100%;" @selection-change="handleSelectionChange">
                <el-table-column type="selection"  width="55"></el-table-column>
                <el-table-column prop="HouseName" label="房产" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dummy_meter_name" label="虚拟表名称" width="200"></el-table-column>
                <el-table-column prop="calc_start_date" label="上期抄表日期"  width="120" ></el-table-column>
                <el-table-column prop="calc_end_date" label="本期抄表日期"  width="120" ></el-table-column>
                <el-table-column prop="last_used_degree" label="上期用量"  width="100" ></el-table-column>
                <!-- <el-table-column prop="current_used_degree" label="本期用量"  width="100" ></el-table-column> -->
                <el-table-column label="本期用量" width="180">
                  <template slot-scope="scope">
                    <div style="color:red">{{scope.row.current_used_degree}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="last_charge_sum"  label="上期金额" width="100"></el-table-column>
                <!-- <el-table-column prop="current_charge_sum"  label="本期金额" width="100"></el-table-column> -->
                <el-table-column label="本期金额" width="180">
                  <template slot-scope="scope">
                    <div style="color:red">{{scope.row.current_charge_sum}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="is_closing"  label="审核" width="120"></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <div style="color: blue;cursor: pointer;" @click="updataId(scope.row)" v-if="ERP.isPermission(4007006010)">修改</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
          <v-divider></v-divider>
          <div class="pages">
            <Page :total="total" :page-size="page" @on-change="change"  show-total />
          </div>
        </div>
        <div v-if="logs == 2">
          <el-table :data="dessertsLog" height="500" style="width: 99.8%;">
              <el-table-column label="错误原因" show-overflow-tooltip></el-table-column>
              <el-table-column label="发送时间" width="80"></el-table-column>
          </el-table>
        </div>

      </div>
    </div>
    <!-- 计算费用 -->
    <Modal
      v-model="calculate"
      width="700"
      title="计算"
      okText="开始计算"
      :loading="loadingModal"
      @on-ok="calculateMoneyAdd">
      <div>
          <div class="cdj_div">计算虚拟表用量和费用-总计有<span style="color: red;">[{{countsc}}]</span>个计算对象，房产：{{data.homeName}}</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background"><span style="color:red">*</span>应收日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" style="width:100%" v-model="calculation.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background"><span style="color:red">*</span>抄表开始日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" style="width:100%" v-model="calculation.calc_start_date" type="date" placeholder="抄表开始日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background"><span style="color:red">*</span>抄表结束日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" style="width:100%" v-model="calculation.calc_end_date" type="date" placeholder="抄表结束日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="timecount"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   <span style="color: red;">公摊需要一个月一个月按顺序生成，不能同时生成多个月</span><br>
                   虚拟表开始计算的数据准备要求<br/>
                   1、确认水、电，气，油表的本月抄表已经上传;<br/>
                   2、虚拟表的计费开始日期就是该类仪表的上期抄表日期;<br/>
                   3、虚拟表的计费结束日期就是该类仪表的本期间抄表日期;<br/>
                   4、虚拟表的分摊计费表的开始日期和结束日期是所有仪表上次抄表的最小日期和本次抄表的最大日期:<br/>
                   5，可以单独计算基种仪表类型或虚拟表类型，其权限和操作员的可操作仪表权限关联;<br/>
                 </div>
               </div>
          </div>
      </div>
    </Modal>

    <!-- 修改计费时间 -->
    <Modal
      v-model="updateDateModel"
      width="700"
      title="修改计费时间"
      okText="开始修改"
      :loading="loadingModal"
      @on-ok="updateDateAdd">
      <div>
          <div class="cdj_div">修改计费的开始时间、结束时间、应收日期，房产：{{data.homeName}}</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费开始时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.startDate" type="date" placeholder="开始时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费结束时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.endDate" type="date" placeholder="结束时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">应收日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="0"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   <span style="color: red;">修改计费开始时间和计费结束时间，只能修改待审核状态的记录</span><br>
                   1、计费的开始日期、结束日期、应收日期是系统自动根据在收费标准设置中设置的参数进行推算出来的，但是实际费用的收取时间会有变化。<br>
                   2、利用本功能就可以重新批量修改这三个日期。<br>
                   3、如果重新执行了费用核算功能，则这些日期需要重新修改。<br>
                   4、最好先确认了计算出来的费用金额结果已经准确后在来修改。<br>
                   5、这些日期的修改不会影响核算的金额。<br>
                   6、新录入的开始日期和结束日期必须在已经结账过的费用日期之外。<br>
                   <span style="color:red;">7、请至少输入一个日期，如果没有输入日期，则表示不做修改。</span>
                 </div>
               </div>
          </div>
      </div>
    </Modal>
    <!-- 修改 -->
    <Modal
      v-model="addmodel"
      width="950"
      title="虚拟表用量/费用"
      okText="保存"
      :loading="loadingModal"
      @on-ok="orderAdd">
      <div>
          <div class="cdj_div">虚拟表用量/费用信息</div>
           <div class="cdj_table">
              <div class="cdj_display">
                <!-- 左 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>房产</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.HouseName" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收日期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:100%" v-model="houesmoney.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>上期读数</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.last_used_degree" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>上期单价</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.last_price" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>上期金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.last_charge_sum" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">备注</div>
                    <div class="cdj_el-input">
                        <el-input type="textarea" size="mini" v-model="houesmoney.remark"></el-input>
                    </div>
                  </div>
                </div>
                <!-- 右 -->
                <div class="cdj_left">
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">虚拟表名称</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.dummy_meter_name" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费周期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.calc_start_date" type="date" placeholder="开始时间"></el-date-picker>
                      <span style="margin-top: 3.5px;">至</span>
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.calc_end_date" type="date" placeholder="结束时间"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>本期读数</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.current_used_degree"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>本期单价</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.current_price"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>本期金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.current_charge_sum"></el-input>
                    </div>
                  </div>
                </div>
              </div>
           </div>
      </div>
    </Modal>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>

</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
const chargeItem_name_id = [];
export default {
  name: "FormsOweMoney",
  data () {
    return {
      calculation:{
        should_charge_date:'',
        calc_start_date:'',
        calc_end_date:'',
      },
      tableData: [],
      house:'',
      modal1:false,
      houesmoney:{},
      selectList:[],
      dessertsLog:[],
      totallog:0,
      pagelog:12,
      calculate:false,
      addmodel:false,
      updateDateModel:false,
      loadingModal:true,
      activeName: 'first',
      startDate:'',
      endDate:'',
      s_startDate:'',
      e_endDate:'',
      chargeitem:[],
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        house_id:'',
        homeName:'',
        s_startDate:'',
        e_endDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
        days:'2',
        start:'',
        name:'',
        meter_kind:[],
        dummy_meter_name:'',
        house_number:'',
        is_closing:[],
        meter_type_id:[],
        calc_start_date:'',
        calc_end_date:'',
      },
      calculateData:{
        pid:'',
        homeName:'',
        day_type:'2',
        start_type:'',
        startDate:'',
        endDate:'',
      },
      updates:{
        startDate:'',
        endDate:'',
        should_charge_date:'',
      },
      chargeItem_name_id:[],
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      charges:[],
      charges1:[],
      homeName:'',
      house:'所有房产',
      count:'',
      routineSum:[],
      isIndeterminate: true,
      developer:'',
      discount_type:[],
      timer:'',
      timecount:0,
      ids:'',
      multipleSelection:[],
      meter_type_list:[],
      logs:1,
      countsc:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    // this.change(1);
    //常规收费项目
    this.$myhttp.get('admin/common/chargeitem_name',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem_1 = backdata.data.data;
        this.chargeitem_2 = backdata.data.data;
    });
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.discount_type = backdata.data.data;
    });
    //仪表类型
    this.$myhttp.get('admin/common/meter_type_list',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.meter_type_list = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //获得面积
    houseCharging(e){
      this.selectList.map(req=>{
        if(req.id==e){
          this.houesmoney.xsc_Amount=req.charging;
        }
      })
    },
    //获得收费标准单价
    chargeitem_list(e){
      // console.log(e);
      // console.log(this.charges1);
      this.charges1.map(req=>{
        if(req.id == e){
          this.houesmoney.xsc_Price=req.charge;
        }
      })
    },
    //选择客户
    user(){
      this.modal1 = true;
    },
    //点击客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
      this.houesmoney.h_name = this.developer.name;
    },
    //搜索房产
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/common/house_text?text=" +query +"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //计算费用
    calculateMoney(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
      }else{
        this.timecount = 0;
        this.calculate = true;
      }
    },
    //计算费用生成
    calculateMoneyAdd(){
      let data = {'date':this.calculation,'houseData':this.data};
      this.$myhttp.post('admin/ShareMeterCalculation/calculateMoneyAdd',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 200){
            this.change(1);
            this.ids = backdata.data.data;
            //this.$Message.success(backdata.data.message);
            this.calculate = false;
            this.$confirm(backdata.data.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

            }).catch(() => {

            });
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //修改计费周期
    updateDate(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
      }else{
        this.updateDateModel = true;
      }
    },
    updateDateAdd(){
      let data = {'data':this.data,'update':this.updates}
      this.$myhttp.post('admin/ShareMeterCalculation/update_list',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 200){
            this.updateDateModel = false;
            this.change(1);
            this.$Message.success(backdata.data.message);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //删除
    del(){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/del',this.multipleSelection,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //全部删除
    del_list(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/del_list',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    // 审核
    closing(){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/closing',this.multipleSelection,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //全部审核
    list_closing(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/list_closing',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //反审核
    back_closing(){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/back_closing',this.multipleSelection,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               //this.$Message.error(backdata.data.message);
               this.$confirm(backdata.data.message, '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
               }).then(() => {

               }).catch(() => {

               });

             }
        });
      }).catch(() => {

      });
    },
    //全部反审核
    back_list_closing(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeterCalculation/back_list_closing',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               //this.$Message.error(backdata.data.message);
               this.$confirm(backdata.data.message, '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
               }).then(() => {

               }).catch(() => {

               });

             }
        });
      }).catch(() => {

      });
    },
    orderAdd(){
      //ERP.showLoading()
      this.$myhttp.post('admin/ShareMeterCalculation/updateAdd',this.houesmoney,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          //ERP.hideLoading()
          this.loadingModals();
          if(backdata.data.code == 200){
            this.addmodel = false;
            this.$Message.success(backdata.data.message);
            this.change(1);
            //this.change(1);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //修改查询
    updataId(item){
       this.houesmoney =item;
       this.addmodel = true;
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charges = backdata.data.data;
      });
    },
    chargeItem_names1(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney.chargeitemID = '';
          this.charges1 = backdata.data.data;
      });
    },
    //获得当前多少页,分页
    change(e){
      this.logs = 1;
      ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/ShareMeterCalculation/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          if(backdata.data.code == 200){
            let data = backdata.data.data;
            this.tableData = data.data;
            this.total = data.count;
            this.page = data.pageSize;
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //日记分页
    changelog(e){
      this.data.page = e;
      this.$myhttp.post('admin/RoutineExpense/orderRoutineLog',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.dessertsLog = data.data;
          this.totallog = data.count;
          this.pagelog = data.pageSize;
      });
    },
    //查看日记
    log(){
      this.logs = 2;
    },
    //搜索
    searchs(){
      this.change(1);
      this.changelog(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      this.data.house_id = '';
      this.search=tree_str;
      this.house = tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
      this.chargesc(this.data.pid,this.data.homeName);
      this.changelog(1);
      this.counts(this.data.pid,this.data.homeName);
    },
    //计费对象数
    counts(pid,homeName){
      this.$myhttp.get("admin/ShareMeterCalculation/counts?pid="+pid+'&homeName='+homeName,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.countsc = backdata.data.data;
      });
    },
    //加载收费项目
    chargesc(pid,homeName){
      this.chargeItem_name_id = [];
      this.$myhttp.get("admin/RoutineExpense/index?pid="+pid+'&homeName='+homeName,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.charge = backdata.data.data.charge;
          this.count = backdata.data.data.count;
          this.chargeItem_name_id = backdata.data.data.chargeItem_name_id;
      });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },
  },
  watch:{

  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.el-checkbox-group{
  margin-top: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/share/MeterCalculation.vue